import { useQuery } from 'react-query';

import { Category } from '../../../types/Category';
import Api from '../../api/api';

export const getSubCategory = async (subCategoryId: string): Promise<Category> => {
  const [response, bodyOrError] = await Api.get(`sub-categories/${subCategoryId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetSubCategory = (subCategoryId: string) =>
  useQuery(['getSubCategory', subCategoryId], () => getSubCategory(subCategoryId), {
    enabled: !!subCategoryId,
  });
